import { ILinkedObjectGroupSpecifiable } from "../../../../../../../documaker/domain/format/objects";
import { IXElementContentsObjectRelationalItemBean } from "../../../beans";
import { ILinkedObjectTranslatable } from "./ILinkedObjectTranslatable";

export interface LinkedObjectGroupTranslateOption {
  isItemBeanEnable?: (b: IXElementContentsObjectRelationalItemBean) => boolean;
  complementBean?: (b: IXElementContentsObjectRelationalItemBean) => void;
}

export class LinkedObjectGroupTranslator implements ILinkedObjectTranslatable<ILinkedObjectGroupSpecifiable> {
  constructor(private readonly _option?: LinkedObjectGroupTranslateOption) {
  }

  from(bean: IXElementContentsObjectRelationalItemBean): ILinkedObjectGroupSpecifiable {
    return (!this._option || !this._option.isItemBeanEnable || this._option.isItemBeanEnable(bean))
      ? {
        key: bean["@value"],
      }
      : null;
  }

  to(object: ILinkedObjectGroupSpecifiable): IXElementContentsObjectRelationalItemBean {
    const result = {
      "@value": object.key,
    };
    if (this._option && this._option.complementBean) {
      this._option.complementBean(result);
    }
    return result;
  }
}
